/*
  Product media merge — NEW FILE.
  Logic for snippets/product-media-slider rendered with gallery_ui: 'media-product' (the "no variant_image_ media" condition).

  UI:        identical to media-product — same markup, ids and styles, and the SAME Splide options, because the gallery is
             mounted with media-product's own initializeSplide() (assets/product-media.js). window.mainSplide / thumbSplide are
             the usual globals, so hok-pdp.js (mobile dots, thumbnail arrows) works unchanged.
  Logic:     product-media-slider's — the gallery always holds ALL product media (images, videos, 3D models). A shade change does
             not rebuild anything: the slider just moves to the shade's featured media (the old updateSliderPosition(mediaPosition - 1)
             from home-page-develop, now matched through data-media-position so videos / skipped media cannot shift the index).
  Price, SKU, Add to Bag, shade label and ?variant= are still updated by product-media.js (it detects [data-media-slider]).

  Safe to load twice, never mounts a slider twice, re-mounts on Theme Editor section reloads.
*/
(function () {
  'use strict';

  if (window.HokPDPMediaSlider) {
    window.HokPDPMediaSlider.init();
    return;
  }

  var GALLERY = '.product-gallery-custom[data-media-slider]';

  function selectedPosition() {
    var input = document.querySelector('.swatch-element input[type="radio"]:checked');
    return input ? parseInt(input.getAttribute('mediaPosition'), 10) || 0 : 0;
  }

  function slideIndex(position) {
    if (!position) return -1;
    var slides = document.querySelectorAll('#main-carousel .splide__slide');
    for (var i = 0; i < slides.length; i += 1) {
      if (Number(slides[i].getAttribute('data-media-position')) === position) return i;
    }
    return -1;
  }

  function mounted() {
    var splide = window.mainSplide;
    return !!(splide && splide.state && !splide.state.is(7)) /* 7 = DESTROYED */ && !!document.querySelector('#main-carousel.is-initialized');
  }

  function goToPosition(position, instant) {
    var index = slideIndex(position);
    if (index < 0 || !mounted()) return; /* shade without featured media: stay where we are, never blank */
    var splide = window.mainSplide;
    if (instant) {
      var speed = splide.options.speed;
      splide.options = { speed: 0 };
      splide.go(index);
      splide.options = { speed: speed };
    } else {
      splide.go(index);
    }
  }

  function init() {
    if (!document.querySelector(GALLERY)) return;
    if (typeof window.Splide === 'undefined' || typeof window.initializeSplide !== 'function') return;
    if (!mounted()) window.initializeSplide(); /* media-product's own init: same options, destroys any stale instance first */
    goToPosition(selectedPosition(), true); /* ?variant= / first available shade */
  }

  function destroy() {
    [window.mainSplide, window.thumbSplide].forEach(function (instance) {
      if (instance && instance.state && !instance.state.is(7)) instance.destroy(true);
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('.swatch-element input[type="radio"]');
    if (!input || input.closest('.quick-view-slide-container')) return;
    if (!document.querySelector(GALLERY)) return;
    goToPosition(parseInt(input.getAttribute('mediaPosition'), 10), false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector && event.target.querySelector(GALLERY)) init();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector && event.target.querySelector(GALLERY)) destroy();
  });

  window.HokPDPMediaSlider = { init: init, destroy: destroy };
})();
